var carouselPositions;
var halfContainer;
var currentItem;
let container = '#slider-mobileMobileNav';
let containerDiv = '#slider-mobileMobileNav div';

function getCarouselPositions() {
  carouselPositions = [];
  document.querySelectorAll(containerDiv).forEach(function(div) {
    carouselPositions.push([div.offsetTop, div.offsetTop + div.offsetHeight]); 
  })
  halfContainer = document.querySelector(container).offsetHeight/2;
}

getCarouselPositions(); // call it once

function goCarousel(direction) {
  let container = '#slider-mobileMobileNav';
let containerDiv = '#slider-mobileMobileNav product-block';
  var currentScrollTop = document.querySelector(container).scrollTop;
  var currentScrollBottom = currentScrollTop + document.querySelector(container).offsetHeight;
  
  if (currentScrollTop === 0 && direction === 'next') {
      currentItem = 1;
  } else if (currentScrollBottom === document.querySelector(container).scrollHeight && direction === 'previous') {
      currentItem = carouselPositions.length - 2;
  } else {
      var currentMiddlePosition = currentScrollTop + halfContainer;
      for (var i = 0; i < carouselPositions.length; i++) {
        if (currentMiddlePosition > carouselPositions[i][0] && currentMiddlePosition < carouselPositions[i][1]) {
          currentItem = i;
          if (direction === 'next') {
              currentItem++;
          } else if (direction === 'previous') {
              currentItem--    
          }
        }
      }
  } 
  
  document.getElementById('slider-mobileMobileNav').scrollTo({
    top: carouselPositions[currentItem][0],
    behavior: 'smooth' 
  });
  
}
window.addEventListener('resize', getCarouselPositions);